import {Route} from 'react-router-dom'
import PrivateRoute from "context/PrivateRoute";
import CheckWS from "./checkWS";
import LoadersChecker from "./LoadersChecker";

const RoutesHidden = () => {

    return (
        <>
            <Route path="hidden/checker/ws/" element={<PrivateRoute><CheckWS/></PrivateRoute>}/>
            <Route path="hidden/loaders/" element={<PrivateRoute><LoadersChecker/></PrivateRoute>}/>
        </>
    )
}
export default RoutesHidden